export enum OpinionQuestionCategory {
  EMPLOYEE_ENGAGEMENT = 10,
}
